import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Lightweight client-side telemetry for route changes.
 * Logs every navigation with auth state so we can diagnose stuck redirects
 * (e.g. /auth → /app → /onboarding loops).
 */
export const RouteLogger = () => {
  const location = useLocation();
  const { session, loading } = useAuth();
  const prev = useRef<string | null>(null);

  useEffect(() => {
    const from = prev.current;
    const to = location.pathname + location.search;
    const userId = session?.user?.id ?? null;

    // eslint-disable-next-line no-console
    console.log("[Route]", {
      from,
      to,
      authLoading: loading,
      userId,
      hasSession: !!session,
      ts: new Date().toISOString(),
    });

    prev.current = to;
  }, [location.pathname, location.search, session, loading]);

  return null;
};
